import * as React from 'react';
import Loadable from 'react-loadable';
import { Spinner } from '@components/Spinner';
import { JoyHeader } from '@components/JoyHeader';

export const LoadableEventRouter = Loadable({
  loader: () => import('./Router'),
  loading: () => (
    <div style={{ margin: '40px' }}>
      <JoyHeader />
      <Spinner id={'Loadable Event'} style={{ top: '20%', height: '50%' }} />
    </div>
  ),
  render: ({ EventRouter }, { event, customDomain, currentUser }: any) => (
    <EventRouter event={event} customDomain={customDomain} currentUser={currentUser} />
  )
});
